import Cookies from 'js-cookie';

import { isDevEnvironmentSwitcherEnabled } from './environments';

const COOKIE_KEY = 'DEV_FLAGSMITH_OVERRIDES';
const cookieOptions = { path: '/' };

const parseOverrides = (raw) => {
    if (!raw) return {};

    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};

        return Object.entries(parsed).reduce((acc, [key, value]) => {
            if (typeof value === 'boolean') acc[key] = value;
            return acc;
        }, {});
    } catch {
        return {};
    }
};

export const getFlagOverrides = () => {
    if (!isDevEnvironmentSwitcherEnabled()) return {};
    return parseOverrides(Cookies.get(COOKIE_KEY));
};

export const hasFlagOverrides = () => Object.keys(getFlagOverrides()).length > 0;

export const setFlagOverride = (key, value) => {
    if (!isDevEnvironmentSwitcherEnabled() || !key) return;

    const next = { ...getFlagOverrides() };

    if (value === null || value === undefined) {
        delete next[key];
    } else {
        next[key] = Boolean(value);
    }

    if (Object.keys(next).length === 0) {
        Cookies.remove(COOKIE_KEY, cookieOptions);
        return;
    }

    Cookies.set(COOKIE_KEY, JSON.stringify(next), cookieOptions);
};

export const clearFlagOverrides = () => {
    Cookies.remove(COOKIE_KEY, cookieOptions);
};

/** Merge cookie overrides onto Flagsmith-derived flag map. Cookie wins when present. */
export const applyFlagOverrides = (flags = {}) => {
    const overrides = getFlagOverrides();
    if (Object.keys(overrides).length === 0) return { ...flags };

    return {
        ...flags,
        ...overrides,
    };
};
